<template>
  <ca-rollover
    ref="rollover"
    :title="rolloverTitle"
    @close="onHandleCloseButton">
    <ca-loader v-if="showLoading"></ca-loader>
    <ca-tabs
      v-else
      :key="tabKey"
      :active="activeTab"
      :on-change="onChangeTab"
      theme="white"
      class="ca-u-margin-top">
      <ca-tab
        label="Dados do Contrato"
        class="ca-u-margin-top"
        :badge-text="getStatusDescription(workerBasicInfo)"
        :badge-theme="getStatusColor(workerBasicInfo)">
        <worker-contract-data-tab
          :is-edit-mode="isEditModeContract"
          :contract-data.sync="contractData"
          @toggle-edit-mode="toggleEditModeContract"
          @on-is-form-valid="onIsContractFormValid"></worker-contract-data-tab>
      </ca-tab>

      <ca-tab
        label="Dados Pessoais"
        class="ca-u-margin-top"
        :badge-text="getStatusDescription(workerBasicInfo.personalData)"
        :badge-theme="getStatusColor(workerBasicInfo.personalData)">
        <worker-personal-data-tab
          :is-edit-mode="isEditModePersonal"
          :personal-data.sync="personalData"
          @toggle-edit-mode="toggleEditModePersonal"
          @on-is-form-valid="onIsPersonalFormValid"></worker-personal-data-tab>
      </ca-tab>
    </ca-tabs>

    <div slot="footer">
      <worker-view-rollover-footer
        v-if="!showLoading"
        :active-tab="activeTab"
        :is-edit-mode-contract="isEditModeContract"
        :is-edit-mode-personal="isEditModePersonal"
        :contract-data="contractData"
        :personal-data="personalData"
        :is-form-valid="isFormValid"
        @on-save="onSave"
        @on-approve="onApprove"
        @on-save-and-approve="onApprove(true)"
        @on-close="onClose"
        @on-delete="onDelete"
        @edit-contract-data="onEditContract"
        @edit-personal-data="onEditPersonalData"></worker-view-rollover-footer>
    </div>
  </ca-rollover>
</template>

<script>
import { isUserAccountant } from 'packages/common';
import {
  isStatusApproved,
  isStatusPending,
  isPersonalDataUnregistered,
  getNewPersonalDataStatus,
} from 'accountant/worker/src/services/approvalService';
import WorkerContractDataTab from './components/contract-data-tab/WorkerContractDataTab';
import WorkerPersonalDataTab from './components/personal-data-tab/WorkerPersonalDataTab';
import WorkerViewRolloverFooter from './components/WorkerViewRolloverFooter';
import EditPendingContractlDataAlert from '../EditPendingContractlDataAlert.vue';
import { CommonCrudMixin } from '../../mixins/CommonCrudMixin';
import { TABS_INDEX, WORKFLOW_TASK } from './workerViewRolloverConstants';
import {
  getStatusColor,
  getStatusDescription,
  getDeniedMessage,
  editWorkerData,
} from '../../workersService';
import store from '../../../../store/index';

export default {
  name: 'WorkerViewRollover',
  components: {
    WorkerContractDataTab,
    WorkerPersonalDataTab,
    WorkerViewRolloverFooter,
  },
  mixins: [
    CommonCrudMixin,
  ],
  props: {
    editModeContract: {
      type: Boolean,
      default: false,
    },
    editModePersonal: {
      type: Boolean,
      default: false,
    },
    activeTabProp: Number,
    workerId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      tabKey: 0,
      showLoading: true,
      activeTab: this.activeTabProp || TABS_INDEX.CONTRACT,
      isContractFormValid: false,
      isPersonalFormValid: false,
      contractData: null,
      personalData: null,
      isEditModeContract: this.editModeContract,
      isEditModePersonal: this.editModePersonal,
    };
  },
  computed: {
    workerBasicInfo() {
      return store.state.worker.basicInfo;
    },
    rolloverTitle() {
      return `Dados do funcionário - ${this.showLoading ? '' : this.workerBasicInfo.name}`;
    },
    isContractPending() {
      return isStatusPending(this.workerBasicInfo.workflowTask);
    },
    isContractApproved() {
      return isStatusApproved(this.workerBasicInfo.workflowTask);
    },
    isPersonalPending() {
      return isStatusPending(this.workerBasicInfo?.personalData?.workflowTask);
    },
    isPersonalApproved() {
      return isStatusApproved(this.workerBasicInfo?.personalData?.workflowTask);
    },
    isPersonalUnregistered() {
      return isPersonalDataUnregistered(this.workerBasicInfo);
    },
    isFormValid() {
      return (this.activeTab === TABS_INDEX.CONTRACT && this.isContractFormValid)
        || (this.activeTab === TABS_INDEX.PERSONAL && this.isPersonalFormValid);
    },
    shouldShowEditPersonalDataAlert() {
      return this.activeTab === TABS_INDEX.PERSONAL && this.isContractPending && isUserAccountant();
    },
  },
  created() {
    this.initData();
  },
  methods: {
    getStatusColor,
    getStatusDescription,
    getDeniedMessage,
    async initData() {
      await store.dispatch('worker/getWorkerBasicInfo', this.workerId);
      this.workerName = store.state.worker.basicInfo.name;
      this.showLoading = false;
    },
    onChangeTab(tabIndex) {
      this.activeTab = tabIndex;

      if (this.shouldShowEditPersonalDataAlert && isUserAccountant()) {
        this.$dialogModal(EditPendingContractlDataAlert, {
          on: {
            'on-view-personal-data': () => {
              this.toggleEditModeContract(false);
              this.changeTab(TABS_INDEX.PERSONAL);
            },
            'on-cancel': () => {
              this.toggleEditModePersonal(false);
              this.changeTab(TABS_INDEX.CONTRACT);
            },
          },
        }).open();
      }
    },
    onHandleCloseButton() {
      this.$emit('update-list');
    },
    onClose() {
      this.$refs.rollover.close();
    },
    toggleEditModeContract(value) {
      this.isEditModeContract = value;
    },
    toggleEditModePersonal(value) {
      this.isEditModePersonal = value;
    },
    changeTab(tab) {
      if (tab === this.activeTab) return;

      this.activeTab = tab;
      this.updateData();
    },
    updateData() {
      this.tabKey++;
      store.dispatch('worker/updateWorkerBasicInfo', this.contractData?.basicInfo || {});
      this.$emit('update-list');
    },
    onIsPersonalFormValid(value) {
      this.isPersonalFormValid = value;
    },
    onIsContractFormValid(value) {
      this.isContractFormValid = value;
    },
    onApprove(shouldSaveWorkerData) {
      const workflowTask = this.isContractPending
        ? this.workerBasicInfo.workflowTask
        : this.workerBasicInfo.personalData?.workflowTask;

      if (this.isContractPending || this.isPersonalPending) {
        this.onApproveMixin({ workflowTask, shouldSaveWorkerData });
      } else {
        this.onApproveSuccess(shouldSaveWorkerData);
      }
    },
    onApproveSuccess(shouldSaveWorkerData) {
      const currentPersonalData = this.contractData?.basicInfo?.personalData || {};
      const data = this.activeTab === TABS_INDEX.CONTRACT
        ? { workflowTask: WORKFLOW_TASK.APPROVED }
        : {
          personalData: { ...currentPersonalData, workflowTask: WORKFLOW_TASK.APPROVED },
          personalDataProvided: true,
        };

      this.contractData = {
        ...this.contractData,
        basicInfo: {
          ...this.contractData?.basicInfo,
          ...data,
        },
      };

      if (shouldSaveWorkerData) {
        this.onSave();
      } else {
        this.onSaveSuccess();
      }
    },
    async onSave() {
      try {
        const data = this.activeTab === TABS_INDEX.CONTRACT ? this.contractData : this.personalData;

        if (this.activeTab === TABS_INDEX.PERSONAL && !isUserAccountant()) {
          await this.updatePersonalDataOnSave();
        }

        await editWorkerData({
          data,
          id: this.workerId,
          activeTab: this.activeTab,
        });

        this.onSaveSuccess();
      } catch (err) {
        // TODO: deixar mensagem dinâmica
        this.$toaster.error('Aconteceu um erro, por favor tente novamente.');
      }
    },
    async updatePersonalDataOnSave() {
      const currentPersonalData = this.contractData?.basicInfo?.personalData || {};

      const workflowStatus = await getNewPersonalDataStatus(this.workerBasicInfo);

      const data = {
        personalData: { ...currentPersonalData, workflowTask: WORKFLOW_TASK[workflowStatus] },
        personalDataProvided: true,
      };

      this.contractData = {
        ...this.contractData,
        basicInfo: {
          ...this.contractData?.basicInfo,
          ...data,
        },
      };
    },
    onSaveSuccess() {
      this.toggleEditModeContract(false);
      this.toggleEditModePersonal(false);
      this.updateData();
      this.$toaster.success('Informações salvas com sucesso!');
    },
    onSaveError() {
      this.$toaster.error('Informações salvas com sucesso!');
    },
    onEditContract() {
      this.changeTab(TABS_INDEX.CONTRACT);
      this.toggleEditModeContract(true);
    },
    onEditPersonalData() {
      this.changeTab(TABS_INDEX.PERSONAL);
      if (this.shouldShowEditPersonalDataAlert) {
        this.onEditPersonalDataAlert();
      } else {
        this.toggleEditModePersonal(true);
      }
    },
    onDelete() {
      this.onDeleteMixin(this.workerId);
    },
    onDeleteSuccess() {
      this.onClose();
      this.$emit('update-list');
    },
    onEditPersonalDataAlert() {
      this.$dialogModal(EditPendingContractlDataAlert, {
        on: {
          'on-view-contract-data': () => {
            this.toggleEditModePersonal(false);
            this.toggleEditModeContract(false);
            this.changeTab(TABS_INDEX.CONTRACT);
          },
          'on-cancel': () => {
            this.toggleEditModePersonal(false);
            this.changeTab(TABS_INDEX.CONTRACT);
          },
        },
      }).open();
    },
  },
};
</script>

<style scoped>
div ::v-deep .ca-dropdown-menu {
  top: unset;
  bottom: 100%;
}

div ::v-deep .ca-tabs-title {
  width: auto;
  min-width: 220px;
}
</style>
